module.exports = __webpack_public_path__ + "img/1.6f5885a9.png";